<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Streamline your app store submission process with powerful automation'
    "
    [icon]="'@tui.sparkles'"
    [subtitle]="'Key Features'"
    [title]="'Everything you need to publish apps'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <!-- One-Click Publishing -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.mouse-pointer-click" class="mr-2" />
        <h3 class="text-xl font-bold">One-Click Publishing</h3>
      </div>
      <p class="text-pretty text-lg">
        Publish your apps to TestFlight, Apple App Store, and Google Play Store
        with a single click. No manual uploads required.
      </p>
    </div>
    <!-- Seamless Integration -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.link" class="mr-2" />
        <h3 class="text-xl font-bold">Seamless Integration</h3>
      </div>
      <p class="text-pretty text-lg">
        Works perfectly with Native Builds to create a complete CI/CD pipeline
        from code to store automatically.
      </p>
    </div>
    <!-- Multiple Store Destinations -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.store" class="mr-2" />
        <h3 class="text-xl font-bold">Multiple Store Destinations</h3>
      </div>
      <p class="text-pretty text-lg">
        Support for TestFlight, Apple App Store, and multiple Google Play tracks
        (Internal, Alpha, Beta, Production) all from one platform.
      </p>
    </div>
    <!-- Secure Credential Storage -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.lock" class="mr-2" />
        <h3 class="text-xl font-bold">Secure Credential Storage</h3>
      </div>
      <p class="text-pretty text-lg">
        Store App Store Connect and Google Play Console credentials securely
        with encryption. Never exposed in logs or build outputs.
      </p>
    </div>
    <!-- Multi-Platform Support -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.smartphone" class="mr-2" />
        <h3 class="text-xl font-bold">Multi-Platform Support</h3>
      </div>
      <p class="text-pretty text-lg">
        Publish both iOS and Android apps from the same platform. Manage all
        your app store submissions in one place.
      </p>
    </div>
    <!-- CLI Tool -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.terminal" class="mr-2" />
        <h3 class="text-xl font-bold">CLI Tool for Automated Publishing</h3>
      </div>
      <p class="text-pretty text-lg">
        Use our CLI tool to automate publishing from your CI/CD pipeline or
        trigger submissions programmatically via our API.
      </p>
    </div>
  </div>
</section>
